module.exports = __webpack_public_path__ + "static/media/biking.32b3104f.png";